export default class Navigation {
    constructor($navigation) {
        this.$navigation = $navigation;
        this.checkSticky = this.checkSticky.bind(this);
        this.setNavigationStickyTreshold = this.setNavigationStickyTreshold.bind(this);

        if (this.$navigation.dataset.calculateStickyTreshold !== undefined) {
            this.stickyBottom = true;
            this.setNavigationStickyTreshold();
            window.addEventListener('resize', this.setNavigationStickyTreshold);
        } else {
            this.navigationStickyTreshold = 30;
            this.checkSticky();
        }

        window.addEventListener('scroll', this.checkSticky);
    }

    setNavigationStickyTreshold() {
        this.$navigation.classList.remove('navigation--sticky');
        this.$navigation.classList.remove('navigation--sticky-bottom');
        this.$navigation.classList.remove('navigation--hidden');

        if(window.innerWidth >= 768) {
            this.navigationStickyTreshold = this.$navigation.getBoundingClientRect().top  + document.documentElement.scrollTop;

        } else {
            this.navigationStickyTreshold = this.$navigation.getBoundingClientRect().bottom  - document.documentElement.clientHeight;
        }

        this.checkSticky();
    }

    checkSticky() {
        let scrollPosition = window.pageYOffset;

        if(this.stickyBottom) {
            const bottomScrollPosition = scrollPosition + document.documentElement.clientHeight;

            if(bottomScrollPosition < (this.navigationStickyTreshold + this.$navigation.getBoundingClientRect().height)) {
                this.$navigation.classList.add('navigation--sticky-bottom');
            } else {
                this.$navigation.classList.remove('navigation--sticky-bottom');
            }
        }

        if (scrollPosition > this.navigationStickyTreshold) {
            this.$navigation.classList.add('navigation--sticky');
        } else {
            this.$navigation.classList.remove('navigation--sticky');
        }

        let hiddenTreshold = window.innerWidth >= 768 ? this.navigationStickyTreshold + 70 : this.navigationStickyTreshold;
        hiddenTreshold = hiddenTreshold > 0  ? hiddenTreshold : 0;

        if (scrollPosition > hiddenTreshold) {
            this.$navigation.classList.add('navigation--hidden');
        } else {
            this.$navigation.classList.remove('navigation--hidden');
        }

        if(this.lastScrollPosition > scrollPosition) {
            this.$navigation.classList.remove('navigation--hidden');
        }

        this.lastScrollPosition = scrollPosition;
    }
}